import "reset-css/reset.css";
import "@fontsource/montserrat";
import "@fontsource/montserrat/200.css";
import "@fontsource/montserrat/300.css";
import "@fontsource/montserrat/400.css";
import "@fontsource/montserrat/500.css";
import "@fontsource/montserrat/600.css";
import "@fontsource/montserrat/700.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { GlobalStyled } from "./styles";
import { RootStoreProvider } from "./stores";
import { ForgotModal, SignInModal, SignUpModal, UnitingModal, WelcomeModal } from "./components";
import { Notifications } from "./components/common/Notifications/Notifications";
import { ViewIframe } from "./components/ui/Other/ViewIrame/ViewIframe";
import { AccessLimitModal } from "./components/ui/Modals/AccessLimitModal/AccessLimitModal";

import weekday from "dayjs/plugin/weekday";
import dayjs from "dayjs";

import "dayjs/locale/en.js";
import "dayjs/locale/ru.js";

import "./i18n";

dayjs.extend(weekday);

const root = ReactDOM.createRoot(document.getElementById("mc_app") as HTMLElement);

root.render(
	<React.StrictMode>
		<HelmetProvider>
			<RootStoreProvider>
				<BrowserRouter
					future={{
						v7_startTransition: true,
						v7_relativeSplatPath: true,
					}}
				>
					<App />
					<GlobalStyled />

					<Notifications />
					<SignInModal />
					<SignUpModal />
					<ForgotModal />
					{/*<GrandChartModal />*/}
					<ViewIframe />
					<UnitingModal />
					{/*<TrialNotification />*/}

					<AccessLimitModal />
					<WelcomeModal />
				</BrowserRouter>
			</RootStoreProvider>
		</HelmetProvider>
	</React.StrictMode>,
);

// Delete preloader
(() => {
	// Find preloader
	const preloader = document.querySelector(".mc_app_preloader");

	// Remove element
	if (preloader) {
		preloader.remove();
	}
})();
